import { getUserData } from "./authnicate";
import { getPermissions, canAccessPage, ROLES } from "../constants/Roles";

// Normalize role string to match ROLES constants (case-insensitive)
const normalizeRole = (role) => {
  if (!role) return null;
  const r = String(role).toLowerCase().trim();
  if (r === "admin" || r.includes("admin")) return ROLES.ADMIN;
  if (r === "spoc" || r.includes("spoc")) return ROLES.SPOC;
  if (r === "finance" || r.includes("finance")) return ROLES.FINANCE;
  return role; // return as-is if unknown
};

// Get the current user's role from localStorage
export const getCurrentRole = () => {
  const user = getUserData();
  if (!user) return null;
  if (Array.isArray(user.roles) && user.roles.length > 0) {
    const knownRole = user.roles.find((r) => {
      const lower = String(r || "").toLowerCase();
      return (
        lower.includes("admin") ||
        lower.includes("spoc") ||
        lower.includes("finance")
      );
    });
    if (knownRole) return normalizeRole(knownRole);
    return normalizeRole(user.roles[0]);
  }
  if (user.role) return normalizeRole(user.role);
  return null;
};

// Get permissions object for the current user
export const usePermissions = () => {
  const role = getCurrentRole();
  return getPermissions(role);
};

// Check if current user can access a given page slug
export const useCanAccessPage = (page) => {
  const role = getCurrentRole();
  return canAccessPage(role, page);
};
